import { render, staticRenderFns } from "./ModalCreateCustomerComplaintReport.vue?vue&type=template&id=44126ca1&scoped=true"
import script from "./ModalCreateCustomerComplaintReport.vue?vue&type=script&lang=js"
export * from "./ModalCreateCustomerComplaintReport.vue?vue&type=script&lang=js"
import style0 from "./ModalCreateCustomerComplaintReport.vue?vue&type=style&index=0&id=44126ca1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44126ca1",
  null
  
)

export default component.exports